import React from "react";
import {
    Table, Input, Space, Tooltip
} from 'antd';
import Button from "antd-button-color";
import Highlighter from 'react-highlight-words';
import { SearchOutlined, FundViewOutlined, UndoOutlined, DeleteOutlined } from '@ant-design/icons';
import { getSaleList } from "./service";
import { Link } from "react-router-dom";
import moment from 'moment';

class Track extends React.Component {
    state = {
        searchText: '',
        searchedColumn: '',
        sortedInfo: null,
        data: null,
        visible: false,
        current: 1,
        pageSize: 10
    };

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        getSaleList().then(res => {
            // console.log("res===", res)
            if (res && res.status === 200) {
                this.setState({
                    data: res.data.info
                })
            }
        })
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({ closeDropdown: false });
                            this.setState({
                                searchText: selectedKeys[0],
                                searchedColumn: dataIndex,
                            });
                        }}
                    >
                        Filter
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select(), 100);
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    getColumnSearchProps2 = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({ closeDropdown: false });
                            this.setState({
                                searchText: selectedKeys[0],
                                searchedColumn: dataIndex,
                            });
                        }}
                    >
                        Filter
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select(), 100);
            }
        },
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    };

    handleChange = (pagination, filters, sorter) => {
        // console.log('Various parameters', pagination, filters, sorter);
        this.setState({
            filteredInfo: filters,
            sortedInfo: sorter,
            current: pagination.current,
            pageSize: pagination.pageSize
        });
    };

    clearFilters = () => {
        this.setState({ filteredInfo: null });
    };

    clearAll = () => {
        this.setState({
            filteredInfo: null,
            sortedInfo: null,
        });
    };

    setAgeSort = () => {
        this.setState({
            sortedInfo: {
                order: 'descend',
                columnKey: 'age',
            },
        });
    };

    showDrawer = () => {
        this.setState({
            visible: true,
        });
    };

    onClose = () => {
        this.setState({
            visible: false,
        });
    };

    dd = () => {
        console.log("dd===", this.state)
    }
    render() {
        // let { sortedInfo } = this.state;
        // sortedInfo = sortedInfo || {};
        var current = this.state.current
        var pageSize = this.state.pageSize
        const columns = [
            {
                title: 'ลำดับ',
                align: 'center',
                width: '4%',
                key: 'no',
                render: (text, record, index) => {
                    return (((current - 1) * pageSize) + index + 1)
                },
            },
            {
                title: 'ชื่อผู้รับผิดชอบ',
                dataIndex: ['firstName_th', 'lastName_th'],
                key: 'firstName_th',
                width: '11%',
                render: (text, record) => (
                    <Space size="small">
                        {record.firstName_th}{record.lastName_th}
                    </Space>
                ),
                // ellipsis: true,
                ...this.getColumnSearchProps2('firstName_th'),
            },
            {
                title: 'รหัสเขต',
                dataIndex: 'saleAreaCd',
                key: 'saleAreaCd',
                width: '5%',
                ...this.getColumnSearchProps('saleAreaCd'),
            },
            {
                title: 'ชื่อเขต',
                dataIndex: 'saleAreaDesc',
                key: 'saleAreaDesc',
                width: '8%',
                ...this.getColumnSearchProps('saleAreaDesc'),
            },
            {
                title: 'ชื่อร้านค้า',
                dataIndex: 'store_name',
                key: 'store_name',
                width: '14%',
                ...this.getColumnSearchProps('store_name'),
            },
            {
                title: 'เวลาเข้าพบ',
                dataIndex: 'checkin_at',
                key: 'checkin_at',
                width: '10%',
                ...this.getColumnSearchProps('checkin_at'),
            },
            {
                title: 'เวลาสิ้นสุด',
                dataIndex: 'checkout_at',
                key: 'checkout_at',
                width: '10%',
                ...this.getColumnSearchProps('checkout_at'),
            },
            {
                title: 'ระยะเวลาเข้าพบ',
                dataIndex: ['checkin_at', 'checkout_at'],
                key: 'timedif',
                width: '7%',
                render: (text, record) => (
                    <Space size="small">
                        {record.checkout_at &&
                            moment.utc(moment(record.checkout_at, "YYYY/MM/DD HH:mm:ss").diff(moment(record.checkin_at, "YYYY/MM/DD HH:mm:ss"))).format("HH:mm:ss")
                        }
                    </Space>
                ),
            },
            {
                title: 'เส้นทางการเดินทาง',
                key: 'action',
                width: '5%',
                align: 'center',
                fixed: 'right',
                render: (text, record) => (
                    <Space size="small">
                        <Tooltip title="view time line">
                            <Link to={{
                                pathname: `/track/view`,
                                saleDetail: record
                            }}
                            >
                                <Button with="ghost" type="success" shape="circle" icon={<FundViewOutlined />} size="small" />
                            </Link>
                        </Tooltip>
                    </Space>
                ),
            },
        ];
        return (
            <>
                <Space style={{ marginBottom: 16 }}>
                    <h2>Track View Sale</h2>
                    {/* <div onClick={this.dd}> dd </div> */}
                </Space>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}
                    columns={columns}
                    dataSource={this.state.data}
                    onChange={this.handleChange}
                    scroll={{ x: 1300, y: '100%' }}
                    size="small"
                    rowKey="empCd"
                    bordered
                />
            </>
        )
    }
}

export default Track;
